import { Register } from 'ui/components';

export const RegisterFeature: React.FC<Umbraco.Register> = ({ content }) => {
	return <Register {...content?.properties} />;
};
